import ShowDetail from '@/components/ShowDetail/ShowDetail'
import api from '@/shared/api/api'
import { HTTPValidationError, TestCaseResponseDTO, TestCaseRunResponseDTO } from '@/shared/api/gen/data-contracts'
import { HttpResponse } from '@/shared/api/gen/http-client'
import { useFetch } from '@/shared/hooks/useFetch'
import { RictTextField, TextField } from '@/shared/ui/Fields/Fields'
import { MultiFileInput, AttachmentItem } from '@/shared/ui/Inputs/FileInput/MultiFileInput'
import { FlexColumn } from '@/shared/ui/Layouts/Flex'

type Props = {
    testCaseRunID: number;
}

function TestRunDetail({ testCaseRunID }: Props) {
    const { data: testCaseRun } = useFetch<TestCaseRunResponseDTO>(
        () => api.test_runs.getCaseTestRunDetailApiTestRunsTestCasesIdGet(Number(testCaseRunID)),
        {} as any,
        [testCaseRunID]
    );
    const { data: testCase } = useFetch<TestCaseResponseDTO>(
        () =>
            testCaseRun?.test_case_ref
                ? api.test_cases.getTestcasesDetailApiTestCasesIdGet(Number(testCaseRun.test_case_ref))
                : Promise.resolve({data: {}} as HttpResponse<TestCaseResponseDTO, HTTPValidationError>),
        {} as any,
        [testCaseRun.test_case_ref]
    );

    const attachments: AttachmentItem[] = Array.isArray((testCaseRun as any)?.attachments)
        ? (testCaseRun as any).attachments
        : [];

    return (
        <FlexColumn style={{ width: '100%' }}>
            <h1 className='text-24' style={{ alignSelf: 'flex-start' }}>Выполнение тест-кейса</h1>
            <ShowDetail title="" record={testCase}>
                <TextField key="title" label='Название тест-кейса' />
                <TextField key="description" label='Описание тест-кейса' />
                <RictTextField key="precondition" label='Предварительные условия тест-кейса' />
                <RictTextField key="steps" label='Шаги воспроизведения тест-кейса' />
                <RictTextField key="postcondition" label='Действия после завершения тест-кейса' />
            </ShowDetail>
            <ShowDetail title={''} record={testCaseRun}>
                <h2 className='text-24'>Результаты тестирования</h2>
                <TextField key="status" label='Статус результата теста' />
                <RictTextField key="description" label='Описание результата тестирования' />
            </ShowDetail>
            {attachments.length > 0 && (
                <div style={{ marginTop: '8px' }}>
                    <p className='text-15'>Вложения результатов</p>
                    <MultiFileInput attachments={attachments} onAdd={async () => {}} onRemove={async () => {}} disabled />
                </div>
            )}
        </FlexColumn>
    );
}

export default TestRunDetail;
